import React from 'react';
import { ReactComponent as UserIcon } from '../../../../assets/images/notifications/circle-user.svg';
import { ReactComponent as SearchIcon } from '../../../../assets/images/notifications/SearchIcon.svg';
import './UserUtilityBar.css';
import CompactNotification from './CompactNotification';
import { useTranslation } from 'react-i18next';

const UserUtilityBar = ( { showUserIcon = false, showSearchIcon = false } ) => {
    const { t } = useTranslation(["translation"]);
    return (
        <>
            <div className="user-utility-bar">
                <div className="icon-group">
                    <div className='notification-container'>
                        <CompactNotification />
                    </div>
                    { showUserIcon && <UserIcon /> }
                </div>
                { showSearchIcon &&
                    <div className="search-box">
                        <SearchIcon />
                        <input
                            type="text"
                            className="search-input"
                            placeholder={t("FORM_CONTENT.FORM_PLACEHOLDER.SEARCH_KEYWORD")}
                        />
                    </div>
                }
            </div>
        </>

    );
};

export default React.memo(UserUtilityBar);
